export const ConsumerProfileAssetOverviewUat = {
  submitButton: 'workflow.consumerAssetOverview.submitButton',
}
